<template>
  <v-container v-if="!isLoggedIn">
    <v-layout row>
      <v-flex xs12 sm6 md6>
        <v-img
          :src="require('@/assets/Signup-Login.svg')"
          height="auto"
        ></v-img>
      </v-flex>
      <v-flex xs12 sm6 md6 class="ml-5">
        <v-layout row wrap justify-center>
          <h5 class="display-2 font-weight-bold mb-3 text-center">
            Registration
          </h5>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-alert :value="getAuthResponse" type="warning">
            {{ getAuthResponse }}
          </v-alert>
        </v-layout>
        <!-- <v-layout row wrap justify-center v-else>
          <v-alert :value="getAuthResponse" type="warning">
            {{ $store.state.auth.responseMsg }}
          </v-alert>
        </v-layout> -->

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="allFormData.name"
            :rules="nameRules"
            label="Name"
            required
          ></v-text-field>

          <v-text-field
            v-model="allFormData.company_name"
            label="Company Name(optional)"
            required
          ></v-text-field>

          <v-text-field
            v-model="allFormData.email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>

          <v-text-field
            v-model="allFormData.phone"
            :rules="phoneRules"
            label="Phone"
            type="number"
            required
          ></v-text-field>

          <v-text-field
            v-model="allFormData.password"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            :rules="[required, min6]"
            label="Password"
            required
          >
          </v-text-field>
          <div>
            <v-text-field
              v-model="allFormData.password_confirmation"
              :type="show2 ? 'text' : 'password'"
              @click:append="show2 = !show2"
              :append-icon="show2 ? 'visibility' : 'visibility_off'"
              :rules="[required, min6, matchingPasswords]"
              label="Confirm Password"
              required
            >
            </v-text-field>
          </div>
          <!-- <v-checkbox
            v-model="checkbox"
            :rules="[(v) => !!v || 'You must agree to continue!']"
            label="Do you agree?"
            required
          ></v-checkbox> -->

          <v-btn
            :disabled="!valid"
            color="success"
            class="mx-0"
            @click="register(allFormData)"
          >
            Submit
          </v-btn>
          <v-btn color="error" @click="reset">Clear</v-btn>
          <p class="mt-3 mb-1 custom-font-size">
            Are you an existing user for DataDash Solution?
            <router-link
              to="/signin"
              tag="span"
              style="cursor: pointer; color: #42a5f5"
            >
            Sign In
            </router-link>
          </p>
          <!-- <v-btn color="warning" @click="resetValidation">
            Reset Validation
          </v-btn> -->
        </v-form>
      </v-flex>
      <v-flex xs1 sm1 md2 lg3></v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  data: () => ({
    show1: false,
    show2: false,
    valid: true,
    successPass: false,
    successPass1: false,
    allFormData: {
      name: "",
      company_name: "",
      email: "",
      phone: "",
      password: "",
      password_confirmation: "",
    },
    nameRules: [(v) => !!v || "Name is required"],
    phoneRules: [
      (v) => !!v || "Phone is required",
      (v) => (v && v.length == 11) || "Should be 11 digits.",
    ],
    emailRules: [(v) => /.+.@.+/.test(v) || "E-mail must be valid"],
    password_confirmation: null,
    checkbox: false,
  }),

  computed: {
    ...mapGetters(["isLoggedIn", "getAuthResponse"]),
    passRule: function () {
      if (this.password === "") {
        // field is empty
        return false;
      } else if (this.min6(this.allFormData.password) === true) {
        // password ok
        return true;
      } else {
        // password wrong
        return false;
      }
    },
    passRule1: function () {
      if (this.allFormData.password_confirmation === "") {
        // field is empty
        return false;
      } else if (
        this.min6(this.allFormData.password_confirmation) === true &&
        this.matchingPasswords() === true
      ) {
        // password ok
        return true;
      } else {
        // password wrong
        return false;
      }
    },
  },

  methods: {
    matchingPasswords: function () {
      if (
        this.allFormData.password === this.allFormData.password_confirmation
      ) {
        return true;
      } else {
        return "Passwords does not match.";
      }
    },
    required: function (value) {
      if (value) {
        return true;
      } else {
        return "This field is required.";
      }
    },
    min6: function (value) {
      if (value.length >= 6) {
        return true;
      } else {
        return "Password should have more than 6 characters.";
      }
    },
    validate() {
      if (this.allFormData.password != this.allFormData.password_confirmation) {
        return (this.show1 = true);
      } else {
        this.show1 = false;
      }
    },

    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    ...mapActions(["register"]),
  },
};
</script>
<style scoped>
.custom-font-size {
  font-size: 13px;
}
</style>